export enum Team {
  Compliance = 'Compliance',
  Risk = 'Risk',
  Default = 'Default'
}

export const teamVisibilityDictionary = [
  {
    key: 'Compliance',
    value: Team.Compliance
  },
  {
    key: 'Compliance & Risk',
    value: Team.Risk
  },
  {
    key: 'Everyone',
    value: Team.Default
  }
];

const hierarchyMap = {
  [Team.Compliance]: 0,
  [Team.Risk]: 1,
  [Team.Default]: 2
};

export const computeVisibilityDictionary = (
  teamName: Team
): typeof teamVisibilityDictionary => {
  const index = hierarchyMap[teamName];
  return teamVisibilityDictionary.slice(index);
};
